// extracted by mini-css-extract-plugin
export default {"img":"async-image_img__IkyXh"};